import { DocumentFilter } from '@getaccept/lib-shared/src/enums/document-filter';
import type { ContractFilter } from '../types';

export const defaultContractsLimit = 20;

export const defaultContractsFilter: ContractFilter = {
  documentFilter: DocumentFilter.Active,
  userIds: undefined,
  orderBy: undefined,
  limit: defaultContractsLimit,
  pageNumber: 0,
  tagIds: undefined,
  withoutTags: false,
  nameSearch: '',
};
